var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"binds-table-cell",class:_vm.cellClasses},[_c('div',{staticClass:"binds-table-cell-container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }